// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__36A3A","box":"WorkspacesBox_box__3zvUA","node":"WorkspacesBox_node__2BWJk"};